@if (show) {
  <div class="light-error-box">
    <button
      class="light-error-box-close light-btn light-btn-xs light-btn-link"
      (click)="close()"
      aria-label="Close"
    >
      <i class="ico-cancel" aria-hidden="true"></i>
    </button>
    <ul>
      @for (msg of messages; track msg) {
        <li class="validation_error">{{ msg | translate }}</li>
      }
    </ul>
  </div>
}
